
import React, { Component } from 'react';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { css } from 'react-emotion';
import { Redirect } from 'react-router-dom';
// First way to import
import { ClipLoader } from 'react-spinners';
import USBUploadService from '../Services/USBUploadService/usbUploadService';

const override = css`
    display: block;
    margin: 0 auto;
    border-color: red;
`;

class EasyClockingImportFile extends Component {

    constructor(props) {
        super(props);
        this.state = {
            selectedFile: null,
            loaded: 0,
            FileName: "Choose a file",
            UploadFileName: "Choose File",
            loading: false,
            isAutenticated: true
        };
        this.changeFileName = this.changeFileName.bind(this);
        this.handleUpload = this.handleUpload.bind(this);
    }
    changeFileName(e) {

        var uploadedFile = e.target.files[0];
        var name = e.target.files[0] ? e.target.files[0].name : "Choose File";
        if (uploadedFile) {
            let reader = new FileReader();
            reader.onload = (progressEvent) => {
                let target = progressEvent.target;
                let result = target.result;
                this.setState({
                    UploadFileName: name,
                    selectedFile: result
                });
            };
            reader.readAsDataURL(uploadedFile);
        } else {
            this.setState({
                UploadFileName: "Choose File",
                selectedFile: ""
            });
        }
    }
    handleUpload() {
        var CompanyCode = this.props.CompanyCode;
        var email = sessionStorage.getItem('email');
        var file = this.state.selectedFile;
        var that = this;
        that.setState({
            loading: true
        });
        if (file === "" || file === null || file === undefined) {
            that.setState({
                selectedFile: null,
                UploadFileName: "Choose File",
                loading: false
            });
            toast.warning("Please Choose a File!", {
                className: {
                    opacity: 0.8
                }
            });
            return false;
        }
        var DataResult = USBUploadService.USBUploadTE(file, CompanyCode, email);
        DataResult.then(function (data) {
            if (data.data === "OK") {
                that.setState({
                    selectedFile: null,
                    FileName: "Choose File",
                    UploadFileName: "Choose File",
                    loading: false
                });
                toast.success("Saved!", {
                    className: {
                        opacity: 0.8
                    }
                });
            } else if (data.data === "Device_UsbMaxSizeFile") {
                that.setState({
                    selectedFile: null,
                    FileName: "Choose File",
                    UploadFileName: "Choose File",
                    loading: false
                });
                toast.error("File's size must be less than 10240 KB!", {
                    className: {
                        opacity: 0.8
                    }
                });
            } else if (data.data.Message === "InvalidFormat" || data.data === "InvalidFormat") {
                that.setState({
                    selectedFile: null,
                    FileName: "Choose File",
                    UploadFileName: "Choose File",
                    loading: false
                });
                toast.error("Invalid Format error!", {
                    className: {
                        opacity: 0.8
                    }
                });
            }
        }).catch((error) => {

            that.setState({
                selectedFile: null,
                FileName: "Choose File",
                UploadFileName: "Choose File",
                loading: false
            });
            if (error.response) {
                if (error && error.response && error.response.data.Message === "500") {
                    toast.error("Error Data Base(Error: 500)", {
                        className: {
                            opacity: 0.8
                        }
                    });
                } else if (error && error.response && error.response.data === "NoDB") {
                    toast.error("Company Code dosen't exist!", {
                        className: {
                            opacity: 0.8
                        }
                    });
                } else if (error && error.response && error.response.data === "NotReseller") {
                    toast.error("This User does not have permission!", {
                        className: {
                            opacity: 0.8
                        }
                    });
                } else if (error && error.response && error.response.data.Message === "400") {
                    toast.error("API Error for Reseller", {
                        className: {
                            opacity: 0.8
                        }
                    });
                } else if (error.response.status === 401) {
                    sessionStorage.setItem("user", '');
                    sessionStorage.setItem("token", '');
                    sessionStorage.setItem("rol", '');
                    sessionStorage.setItem("email", '');
                    sessionStorage.clear();
                    this.setState({ isAutenticated: false },
                        () => {
                            this.forceUpdate();
                        })
                }
            } else {
                toast.error("Code Error", {
                    className: {
                        opacity: 0.8
                    }
                });
            }
        });
    }
    render() {

        if (!this.state.isAutenticated) {
            return (<Redirect to={'/login'} />)
        }
        return (
            <div>
                <div className="card Logs"><ToastContainer hideProgressBar />
                    <div className="card-body">
                        <div className="row">
                            <div className="col-2">
                                <h4><span className="badge badge-info">Timeclock File </span></h4>
                            </div>
                            <div className="col-3">
                                {
                                    this.props.CompanyCode
                                    &&
                                    <div className="upload-btn-wrapper" key={Math.random() * 1200000}>
                                        <button style={{ 'width': '100%', 'backgroundColor': '#00C851', 'marginLeft': '0px' }} onClick={(e) => this.fileInput.click(e)} className="btn btn-primary">{this.state.UploadFileName}</button>
                                        <input ref={input => this.fileInput = input} type="file" name="myfile" style={{ 'display': 'none' }} onChange={(event) => { this.changeFileName(event) }} />

                                    </div>
                                }
                            </div>
                            <div className="col-3">
                                <ClipLoader
                                    className={override}
                                    sizeUnit={"px"}
                                    size={30}
                                    color={'#4285F4'}
                                    loading={this.state.loading}
                                />
                                {
                                    this.props.CompanyCode
                                    &&
                                    <button onClick={this.handleUpload} className="btn btn-primary">Upload</button>
                                }
                            </div>
                        </div><br />
                    </div>
                </div>

            </div>
        );
    }
}

export default EasyClockingImportFile;


// WEBPACK FOOTER //
// ./src/ImportFile/EasyClockingImportfile.jsx